import { FC, useEffect, useRef, useState } from "react"
import { Box, IconButton, Tooltip, Typography } from "@mui/material"
import { Visibility, VisibilityOff, ContentCopy } from "@mui/icons-material"
import { useCopyToClipboard } from "../hooks"

interface IProps {
  value: string | null | undefined
  /** Авто-скрытие при потере фокуса/через ~5с (default true). */
  autoHide?: boolean
}

/** Display-only маскировка секрета: •••• + reveal + «скопировать».
 *  Для DataGrid renderCell и detail-страниц. */
export const SecretValue: FC<IProps> = ({ value, autoHide = true }) => {
  const [visible, setVisible] = useState(false)
  const { copied, copy } = useCopyToClipboard()
  const hideTimer = useRef<ReturnType<typeof setTimeout> | undefined>(undefined)

  const show = () => {
    setVisible(true)
    if (autoHide) {
      if (hideTimer.current) clearTimeout(hideTimer.current)
      hideTimer.current = setTimeout(() => setVisible(false), 5000)
    }
  }

  const hide = () => {
    setVisible(false)
    if (hideTimer.current) {
      clearTimeout(hideTimer.current)
      hideTimer.current = undefined
    }
  }

  useEffect(
    () => () => {
      if (hideTimer.current) clearTimeout(hideTimer.current)
    },
    [],
  )

  if (value === null || value === undefined || value === "") {
    return <Typography variant="body2">—</Typography>
  }

  return (
    <Box display="flex" alignItems="center" gap={0.5}>
      <Typography
        variant="body2"
        sx={{ fontFamily: visible ? "monospace" : "inherit" }}
      >
        {visible ? value : "••••"}
      </Typography>
      <Tooltip title={copied ? "Скопировано" : "Копировать"}>
        <IconButton size="small" onClick={() => copy(value)}>
          <ContentCopy fontSize="small" />
        </IconButton>
      </Tooltip>
      <Tooltip title={visible ? "Скрыть" : "Показать"}>
        <IconButton
          size="small"
          onClick={() => (visible ? hide() : show())}
          onBlur={autoHide ? hide : undefined}
        >
          {visible ? (
            <VisibilityOff fontSize="small" />
          ) : (
            <Visibility fontSize="small" />
          )}
        </IconButton>
      </Tooltip>
    </Box>
  )
}
